/** @format */

import { useQuery } from "@tanstack/react-query";
import service from "../utils/service";

const useGetSurveyById = (surveyId, enabled = true) => {
  const allSurvey = useQuery({
    queryKey: ["getSurveyById", surveyId],
    queryFn: () => service.getSurveyByID(surveyId),
    select: (data) => data.data,
    enabled
  });
  return allSurvey;
};

export default useGetSurveyById;
